<template>
  <div>
    <facit-header></facit-header>
      <div class = "profile-div col-12">
        <h5 class="mt-3 mb-3">Login History </h5>
        <b-row class="float-right">
          <b-col class="my-1">
            <b-form-group horizontal label="" class="mb-3">
              <b-input-group>
                <b-form-input v-model="filter" placeholder="Search" />
                <b-btn class="clearBtn" :disabled="!filter" @click="filter = ''">Clear</b-btn>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-table  striped hover
                  show-empty
                  empty-text="There is no login history to show"
                  :fields="tableFields"
                  :filter="filter"
                  :items="history"
                  :current-page="currentPage"
                  :per-page="perPage"
                  @filtered="onFiltered">
        </b-table>
        <br>
        <b-pagination align="right"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      v-model="currentPage"
                      class="my-0" />
        <br><br>
      </div>
  </div>
</template>

<script>
import API from '@/api';
import FacitHeader from '@/components/header';
import moment from 'moment';

export default {
  name: 'loginHistory',
  components: { FacitHeader },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      history: [],
      userSettingsModal: false,
      filter: null,
      moment: moment,
      tableFields: [
        {
          key: 'firstname',
          label: 'First Name',
          sortable: true,
        },
        {
          key: 'lastname',
          label: 'Last Name',
          sortable: true,
        },
        {
          key: 'email',
          label: 'Email Address',
          sortable: true,
        },
        {
          key: 'browserName',
          label: 'Browser Name',
          sortable: true,
        },
        {
          key: 'date',
          label: 'Date',
          sortable: true,
          formatter: (value) => {
            return moment.utc(value).format('DD-MM-YYYY HH:mm');
          },
        },
      ],
    };
  },
  async created() {
    const userId = this.$route.query.id;
    this.getHistory(userId);
  },
  methods: {
    async onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      // this.currentPage = 1
    },
    async getHistory(userId) {
      const historyData  = [];

      this.history = await API.get('Accounts/?filter={"include":{"relation":"browserHistory","scope":{"order": "date DESC"}}}');

      this.history =  this.history.filter(h => h.browserHistory.length > 0);

      this.history = this.history.forEach(h => {
        h.browserHistory.forEach(bh => {
          bh.email = h.email
          bh.firstname = h.firstname
          bh.lastname = h.lastname
          historyData.push(bh);
        });
      });
      historyData.sort((var1, var2) => {
        const a = new Date(var1.date);
        const b = new Date(var2.date);
        if (a < b) return 1
        if (a > b) return -1
        if (a === b) return 0
      });
      this.history = historyData
      this.totalRows = this.history.length;
    },
    users() {
      this.$router.push('/admin/users');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 12px;
  width: 12px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #d6700a;
}

input:focus + .slider {
  box-shadow: 0 0 1px #d6700a;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 20px;
}
.switch input {
  display:none;
}
.icon-width {
  width: 20px !important;
  height: 20px !important;
}
.page-item.active .page-link {
  z-index: 1;
    color: #fff;
    background-color: #6610f2 !important;
    border-color: #6610f2 !important;
}
.profile-div {
  margin-top: 50px;
  margin-left: 50px;
  width: 95% !important;
}
.Userlink {
  color: #df8031 !important;
  text-decoration: none !important;
  cursor: pointer;
}
.clearBtn {
  color: #fff;
  background-color: #ff8f00;
  border-color: #ff8f00;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/loginHistory.vue